<template>
  <div
    :class="['contacting_box ', {'is-past-due': isPastNextContactAt}]"
    v-observe-visibility="{
      callback: isVisible,
      once: true,
    }"
  >
    <contacting-box-record
      :record="record"
      class="contacting_box--lead"
    ></contacting-box-record>

    <div class="contacting_box--notes">
      <contacting-box-notes
        :record="record"
        :notes="record.notes"
      ></contacting-box-notes>
    </div>

    <!--Comms-->
    <div class="contacting_box--comms">
      <app-loading-section :loading="loadingExtraData" style="height: 100%">
        <contacting-box-contact-comms
          :record="record"
          :comms="comms"
          :primaryContact="primaryContact"
        ></contacting-box-contact-comms>
      </app-loading-section>
    </div>

    <!--Next Contact-->
    <div class="contacting_box--next_contact">
      <app-loading-section :loading="loadingExtraData">
        <record-next-contact
          :record="record"
          append-calendar-to-body
        ></record-next-contact>
      </app-loading-section>
    </div>
  </div>
</template>

<script>
import ContactingBoxRecord from "./ContactingBoxRecord";
import ContactingBoxNotes from "./ContactingBoxNotes";
import ContactingBoxContactComms from "./ContactingBoxContactComms";
import api from "../../../../../api";
import dates from "../../../../../services/dates";
import AppDebugging from "../../../../../components/app/AppDebugging.vue";

export default {
  name: "ContactingBox",
  components: {
    AppDebugging,
    ContactingBoxContactComms,
    ContactingBoxNotes,
    ContactingBoxRecord,
  },
  props: {
    record: {
      type: Object,
      required: true
    },
    delay: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loadingExtraData: true,
      comms: [],
      primaryContact: null,
      nowDate: dates.getNowISO()
    };
  },
  mounted() {
    if(this.lazyLoadedRecordData) {
      this.setNewData(this.lazyLoadedRecordData)
    }
  },
  watch: {
    lazyLoadedRecordData(newData) {
      if (newData) {
        this.setNewData(newData)
      }
    }
  },
  computed: {
    // nextTask() {
    //   if (this.record.nextTask) {
    //     return dates.getISO(this.record.nextTask.due_at);
    //   }
    //
    //   return null;
    // },
    // recordIndicator() {
    //   if(dates.isBefore(this.nextTask, this.nowDate)) {
    //     return 'is-danger';
    //   } else if (dates.isBefore(this.nextTask, dates.addDay(this.nowDate))) {
    //     return 'is-warning';
    //   }
    //
    //   return '';
    // },
    isPastNextContactAt() {
      if (this.record.next_contact_at === null) {
        return false;
      }

      const now = new Date();
      const nextContactAt = new Date(this.record.next_contact_at);

      return nextContactAt.getTime() <= now.getTime();
    },
    lazyLoadedRecordData() {
      return this.$store.getters['contactingState/lazyLoadedRecordData'](this.record.id);
    }
  },
  methods: {
    setNewData(data) {
      this.comms = data.comms;
      this.primaryContact = data.primaryContact;
      this.loadingExtraData = false;
    },
    isVisible(isVisible) {
      if (isVisible && this.lazyLoadedRecordData === undefined) {
        this.$store.commit('contactingState/addRecordToPendingLazyLoadedRecords', this.record.id);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../styles/variables/variables";

.contacting_box {
  display: grid;
  grid-template-columns: minmax(310px, 360px) minmax(320px, 1fr) minmax(320px, 400px) minmax(320px, 360px);
  grid-template-rows: 1fr;
  gap: 0 0;
  grid-template-areas: "lead notes comms next_contact";
  margin-bottom: 1rem;
  background-color: $white;
  box-shadow: $box-shadow;
  border-left: 5px solid transparent;
  overflow-x: auto;
  border-bottom: 1px solid $border;

  //&.is-warning {
  //  border-left-color: $yellow;
  //}
  //&.is-danger {
  //  border-left-color: $red;
  //}
  &.is-past-due {
    border-left-color: $red;
  }
  &--lead {
    grid-area: lead;
    padding: $defaultGap;
    border-right: 1px solid $border;
  }

  &--notes,
  &--comms,
  &--next_contact {
    position: relative;
    padding: $defaultGap;
    border-right: 1px solid $border;
  }

  &--notes {
    grid-area: notes;
  }

  &--comms {
    grid-area: comms;
  }

  &--next_contact {
    grid-area: next_contact;
  }
}
</style>
